export const checkMobile = (): boolean => {
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  return isMobile;
}